import { Dtos } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { agentUserPreviewsQueryKey } from "../user.keys";

export const useCompleteAgentUserAccountSetup = () => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		mutationKey: ["completeAgentUserAccountSetup"],
		mutationFn: async (data: Dtos.Agent.CompleteAccountSetup.Request) => {
			await post(`/v2/agents/complete-setup`, data, "none");
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: agentUserPreviewsQueryKey() });
		},
	});

	return {
		completeAgentUserAccountSetup: mutation.mutate,
		completeAgentUserAccountSetupIsLoading: mutation.isPending,
		completeAgentUserAccountSetupError: mutation.error,
		completeAgentUserAccountSetupIsSuccess: mutation.isSuccess,
	};
};
